<div class="products-container">
	<div class="carroussel" [ngStyle]="getStyleCaroussel()">
		<div *ngFor="let product of products" [ngStyle]="getSizeProduct()" class="product">
			<gob-product-card [product]="product"></gob-product-card>
		</div>
	</div>
</div>
